export default __webpack_public_path__ + "static/media/icon-contact-agent.bde9173e.svg";